import React, { useState, useEffect, useRef } from 'react';
import mailFrame from '../assets/login email.png';
import lockFrame from '../assets/login password.png';
import eyeIcon from '../assets/eye vector icon.png';
import logo from '../assets/logo PNG Transparent/Logo-07.png';
import { Link, useNavigate } from 'react-router-dom';
import api from '../sever/Api';
import { toast } from 'react-toastify';
import esscoBg from '../assets/essco-bg.png';
import logo1 from '../assets/new-Logo.png';
import textlogo from '../assets/UnlockYourPotential.png';

const OTP = () => {
    const [otp, setOtp] = useState(new Array(6).fill(''));
    const [timer, setTimer] = useState(60);
    const [isLoading, setIsLoading] = useState(false);
    const inputRefs = useRef([]);
    const navigate = useNavigate();

    useEffect(() => {
        const countdown = setInterval(() => {
            setTimer(prev => (prev > 0 ? prev - 1 : 0));
        }, 1000);
        return () => clearInterval(countdown);
    }, []);

    const handleChange = (element, index) => {
        const val = element.value.replace(/[^0-9]/g, '');
        if (!val) return;

        const newOtp = [...otp];
        newOtp[index] = val;
        setOtp(newOtp);

        if (index < 5 && val) {
            inputRefs.current[index + 1].focus();
        }
    };

    const handleKeyDown = (e, index) => {
        if (e.key === 'Backspace' && !otp[index] && index > 0) {
            inputRefs.current[index - 1].focus();
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const enteredOTP = otp.join('');

        if (enteredOTP.length !== 6) {
            toast.error('Please enter a valid 6-digit OTP');
            return;
        }

        setIsLoading(true);
        try {
            const email = localStorage.getItem('resetEmail');
            if (!email) {
                toast.error('Email not found. Please try forgot password again.');
                navigate('/forgotpassword');
                return;
            }

            const response = await api.post('/api/auth/verify-otp', {
                email,
                otp: enteredOTP
            });

            toast.success('OTP verified successfully');
            // Store OTP and email for reset password page
            localStorage.setItem('resetOTP', enteredOTP);
            localStorage.setItem('resetEmail', email);
            navigate('/resetPassword');
        } catch (error) {
            console.error('OTP verification error:', error);
            const message = error.response?.data?.message || 'Invalid OTP. Please try again.';
            toast.error(message);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            <div className=' min-h-screen bg-[linear-gradient(126.39deg,#F7F6FA_5.58%,#F5F4FC_27.79%,#F2F2FE_48.29%,#F5F4FF_69.65%,#FFF9FF_94.42%)]' style={{
                backgroundImage: `url(${esscoBg})`,
                backgroundSize: 'cover',
                backgroundPosition: 'top',
                backgroundRepeat: 'no-repeat'
            }}>
                <div className="flex flex-row justify-center items-center px-[32px] py-[16px] bg-[rgba(247,248,250,0.01)] shadow-[0px_2px_7px_rgba(0,0,0,0.07)]" >
                    <img src={logo1} alt="HWORK2 Logo" style={{ width: 215, height: 41 }} />
                </div>
                <div className="mt-6 w-full overflow-x-hidden flex items-center justify-center ">


                    {/* Main Login Card */}
                    <div className="w-full max-w-md bg-white rounded-2xl shadow-xl p-8">
                        {/* Card Header */}
                        <div className="text-center mb-8">
                            <div className=" flex items-center justify-center mx-auto mb-4 relative" style={{ width: 123 }}>
                                <img src={logo} alt="HWORK2 Logo" className="w-full h-full" />


                            </div>
                            <h1 className="font-semibold text-[24px] leading-[32px] text-center text-[#151417] mb-2" style={{ fontFamily: 'Lato, sans-serif' }}>The HWORK2 Method</h1>
                            {/* <p className="text-purple-600 italic"style={{fontFamily: 'Playfair Display, serif', fontSize:32}}>Unlock Your Potential</p> */}
                            <img src={textlogo} alt="HWORK2 Logo" className="w-full h-full" />
                        </div>

                        <form onSubmit={handleSubmit} className="space-y-5">
                            {/* OTP Inputs */}
                            <div className="flex justify-between gap-2">
                                {otp.map((digit, index) => (
                                    <input
                                        key={index}
                                        type="text"
                                        maxLength="1"
                                        value={digit}
                                        onChange={(e) => handleChange(e.target, index)}
                                        onKeyDown={(e) => handleKeyDown(e, index)}
                                        ref={(el) => (inputRefs.current[index] = el)}
                                        className="w-10 sm:w-12 h-12 text-center border-2 border border-gray-300 rounded-lg px-2 py-2 focus-within:border-purple-500 transition"
                                    />
                                ))}
                            </div>

                            {/* Timer */}
                            <div className="text-sm text-gray-700 text-center">
                                {timer > 0 ? (
                                    <span>OTP expires in <span className="text-pink-500 font-semibold">{timer}s</span></span>
                                ) : (
                                    <span className="text-red-500 font-semibold">OTP expired</span>
                                )}
                            </div>
                            <button
                                type="submit"
                                className="w-full py-2 sm:py-3 rounded bg-gradient-to-r from-[#7A81FF] to-[#7A81FF] text-white font-bold shadow-md text-sm sm:text-base lg:text-lg disabled:opacity-50 disabled:cursor-not-allowed"
                                disabled={otp.includes('') || timer === 0 || isLoading}
                            >
                                {isLoading ? 'Verifying...' : 'Verify OTP'}
                            </button>
                        </form>
                    </div>
                </div>
            </div>

        </>
    );
};

export default OTP; 